import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ExpenseClaimsInfo } from '../model/ExpenseClaims.model';
import { LookupInfo } from '../model/lookup.model';

@Component({
  selector: 'app-expense-claims',
  templateUrl: './expense-claims.component.html',
  styleUrls: ['./expense-claims.component.css']
})
export class ExpenseClaimsComponent implements OnInit {

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;

  // Primary data
  modelOnPromise: Promise<ExpenseClaimsInfo[]>
  modelList: ExpenseClaimsInfo[] = [];

  // Lookup Data
  ListExpenseType: LookupInfo[] = [];
  ListStatusType: LookupInfo[] = [];

  // Binded variables
  txtSchReceiptDate: string;
  txtSchExpenseType: string = "";
  txtSchExpenseStatus: string = "";
  txtSchTotalAmount: number;
  txtSchRequestBy: string;
  txtSchRemark: string;

  // Pagination variables
  public indexNo: number = 0;
  public currentPageNumber: number;
  public itemTotal: any;
  public totalPages: number;
  public pagesize: number = 15;

  // Modal
  titlemodal: string;
  detailmodal: string;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService, private activatedRoute: ActivatedRoute) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = localStorage.getItem("EmpCode");

    GlobalService.CheckPagingAccessRights();
  }

  //============================ ngOnInit [Start] ===============================================
  ngOnInit(): void {

    console.log(this._EmpCode)

    this.currentPageNumber = 1;
    this.LoadData();

    this.LoadLookup('PROJECTSALEGLCODE').then((data) => {
      this.ListExpenseType = data;
    });
    this.LoadLookup('EXPENSECLAIMSSTATUS').then((data) => {
      this.ListStatusType = data;
    });
  }
  //============================ ngOnInit [End] ===============================================

  //============================ onEvent [Start] ===============================================
  btnClick_setfilter() {
    this.LoadData();
  }
  btnClick_unsetFilter() {

    this.txtSchReceiptDate = "";
    this.txtSchExpenseType = "";
    this.txtSchExpenseStatus = "";
    this.txtSchTotalAmount = null;
    this.txtSchRequestBy = "";
    this.txtSchRemark = "";

    this.LoadData();
  }

  btnClick_deleteMultiple() {
    // TODO
  }
  btnClick_deleteSingle(paramId) {
    this.deleteExpenseClaims(paramId);
  }
  //============================ onEvent [End] ===============================================

  //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getExpenseClaims()
      .then(
        data => {
          this.modelList = data;
          //this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          this.itemTotal = (this.modelList.length != 0) ? data[0].rowTotal : 0;
        }
      ).then(() => {
        if (this.itemTotal == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.itemTotal / environment.PageSize)
      })
  }

  async getExpenseClaims(): Promise<ExpenseClaimsInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {};

      objectjson['ReceiptDate'] = this.txtSchReceiptDate;
      objectjson['ExpenseTypeCode'] = this.txtSchExpenseType;
      objectjson['ExpenseStatusCode'] = this.txtSchExpenseStatus;
      objectjson['TotalAmount'] = this.txtSchTotalAmount;
      objectjson['RequestBy'] = this._EmpCode;
      objectjson['Remark'] = this.txtSchRemark;
      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.modelOnPromise = this.httpClient
        .post<ExpenseClaimsInfo[]>(this.baseurl + "ExpenseClaims/GetExpenseClaimsCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

  async LoadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async deleteExpenseClaims(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{Id: " + id + "}";

      if (confirm("Are you sure you want to delete this expense claims?")) {
        var submitted = this.httpClient.post<boolean>(this.baseurl + "ExpenseClaims/DeleteExpenseClaims", strjsonCusInfo, httpOptions)
          .subscribe(result => submitted = result, failCb => {
            console.log("Update fail")
          },
            () => {

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Expense claims has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-custom-purple');
              $('#ModalComplate').modal();

              this.LoadData();
            }
          )
      }
    }
  }

  //============================ Data Loading [End] =========================================

  //============================ Misc Functions [Start] =========================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput;

  }
  //============================ Misc Function [End] =========================================

  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
  //============================ Pagination [End] =========================================

}
